import React, { ElementType, forwardRef } from 'react';
import { Box, BoxProps } from '@mui/material';
import { ResponsiveStyleValue } from '@mui/system';

export interface SpacingProps extends BoxProps<ElementType> {
  /**
   * Value of spacing. Transpiles to theme.spacing(value).
   *
   * @default 2 that transpiles by default to 16px
   */
  value?: ResponsiveStyleValue<number | string>;
  /**
   * Defines whether the Spacing should be horizontal or vertical.
   * @default: false
   */
  horizontal?: boolean;
}

export const Spacing: React.FC<SpacingProps> = forwardRef(({ sx, value = 2, horizontal = false, ...rest }, ref) => {
  return (
    <Box
      ref={ref}
      sx={{
        pl: horizontal ? value : 0,
        pt: horizontal ? 0 : value,
        ...sx,
      }}
      {...rest}
    />
  );
});
